module.exports = __webpack_public_path__ + "static/craftsman-b67a7b112dd086312afa684232e3c241.png";